module.exports = __webpack_public_path__ + "img/logo-auto-select.1ee13902.png";